import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Dropboxed from "material-ui/svg-icons/content/move-to-inbox";
import Invoiced from "material-ui/svg-icons/editor/monetization-on";
import Drafted from "material-ui/svg-icons/communication/email";
import Booked from "material-ui/svg-icons/notification/confirmation-number";
import Cancelled from "material-ui/svg-icons/content/block";
import Welcome from "material-ui/svg-icons/action/home";

import OurismanTravelTheme from "../../ourismanTravelTheme";
import styles from "./styles.scss";

export default class Trip extends React.Component {
  // eslint-disable-line
  static propTypes = {
    active: PropTypes.bool.isRequired,
    trip: PropTypes.shape().isRequired,
  };

  render() {
    const { active, trip } = this.props;
    const {
      primaryTravelerName,
      destination,
      dateString,
      id,
      ownerName,
      specificDates,
      numTravelers,
      fired,
      lowPriority,
      highPriority,
      needsTraining,
      needsVetting,
      insideCircle,
      numSegments,
      dropbox,
      invoice: invoiced,
      draftVip: vipDrafted,
      book: booked,
      prospect,
      welcomeHome,
    } = trip;

    const cancelledIconColor = OurismanTravelTheme.palette.accent1Color;
    const cancelled = false;

    const flags = [
      fired ? "fired" : false,
      prospect ? "prospect" : false,
      insideCircle ? "insideCircle" : false,
      lowPriority ? "lowPriority" : false,
      needsTraining ? "needsTraining" : false,
      needsVetting ? "needsVetting" : false,
      highPriority ? "highPriority" : false,
    ].filter((flag) => flag !== false);
    const flagLabels = {
      fired: "fired",
      prospect: "prospect",
      insideCircle: "Inside Circle",
      lowPriority: "low priority",
      needsTraining: "needs training",
      needsVetting: "needs vetting",
      highPriority: "BMOC",
    };

    return (
      <Link to={`/trips/${id}/`} className={active ? styles.active : null}>
        <div className={styles.tripListItem}>
          <div className={styles.primaryDetails}>
            <span className={styles.travelerName}>{primaryTravelerName}</span>
            <span>{specificDates ? dateString : "dates TBD"}</span>
            <span>{destination}</span>
          </div>
          <div className={styles.primaryDetails}>
            <span>{numSegments} segments</span>
            <span>{numTravelers} travelers</span>
          </div>
          <div className={styles.secondaryDetails}>
            <span>assigned to: {ownerName}</span>
          </div>
          <div className={styles.indicators}>
            <div className={styles.flags}>
              {/* <div>Tier {tier}</div> */}
              {flags.map((flag, index) => (
                <div key={index} className={styles[flag]}>
                  {flagLabels[flag]}
                </div>
              ))}
            </div>
            <div className={styles.icons}>
              <div className={styles.icon}>
                {(cancelled && <Cancelled />) || (booked && <Booked />) || null}
                <span>{cancelled ? "cancelled" : "book"}</span>
              </div>
              <div className={styles.icon}>
                {dropbox ? (
                  <Dropboxed color={cancelled ? cancelledIconColor : null} />
                ) : null}
                <span>filed</span>
              </div>
              <div className={styles.icon}>
                {invoiced ? (
                  <Invoiced color={cancelled ? cancelledIconColor : null} />
                ) : null}
                <span>invoice</span>
              </div>
              <div className={styles.icon}>
                {vipDrafted ? (
                  <Drafted color={cancelled ? cancelledIconColor : null} />
                ) : null}
                <span>draft</span>
              </div>
              <div className={styles.icon}>
                {welcomeHome ? (
                  <Welcome color={cancelled ? cancelledIconColor : null} />
                ) : null}
                <span>welcome</span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// /src/components/Trips/Trip.js